import { render, staticRenderFns } from "./PubgDesktopAccount.vue?vue&type=template&id=3c2b90ca&lang=pug"
import script from "./PubgDesktopAccount.vue?vue&type=script&lang=js"
export * from "./PubgDesktopAccount.vue?vue&type=script&lang=js"
import style0 from "./PubgDesktopAccount.vue?vue&type=style&index=0&id=3c2b90ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports